<template>
  <div class="goodsInventory">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="container">
          <div class="left">
            <div class="list-item">
              {{ $t.goodsInventory.productName }}：{{ item.ProductName }}
            </div>
            <div class="list-item">
              {{ $t.goodsInventory.productNameEn }}：{{ item.ProductNameEn }}
            </div>
            <div class="list-item">{{ $t.goodsInventory.hsCode }}：{{ item.HSCode }}</div>
            <div class="list-item">{{ $t.goodsInventory.brand }}：{{ item.Brand }}</div>
            <div class="list-item">{{ $t.goodsInventory.model }}：{{ item.Model }}</div>
            <div class="list-item">
              {{ $t.goodsInventory.specification }}：{{ item.Specifications }}
            </div>
            <div class="list-item">
              {{ $t.goodsInventory.unitName }}：{{ item.UnitName }}
            </div>
            <div class="list-item">
              {{ $t.goodsInventory.sixMonthAvgPrice }}：{{ item.SixMonthAvgPrice }}
            </div>
            <div class="list-item">
              {{ $t.goodsInventory.minPrice }}：{{ item.MinPrice }}
            </div>
            <div class="list-item">
              {{ $t.goodsInventory.minPriceCustomerNumber }}：{{
                item.MinPriceCustomerNumber
              }}
            </div>
            <div class="list-item">
              {{ $t.goodsInventory.minPriceCompanyName }}：{{ item.MinPriceCompanyName }}
            </div>
            <div class="list-item">
              {{ $t.goodsInventory.minPriceCustomerPhone }}：{{
                item.MinPriceCustomerPhone
              }}
            </div>
            <div class="list-item">
              {{ $t.goodsInventory.priceValidityPeriod }}：{{ item.PriceValidityPeriod }}
            </div>
          </div>
          <div class="right">
            <div class="images">
              <van-image
                width="88"
                height="88"
                fit="cover"
                @click="imagePreview(imgUrlFilter(item.ProductImages))"
                :src="imgUrlFilter(item.ProductImages)"
                v-if="item.ProductImages.length > 0"
              />
              <span v-else>{{ $t.goodsInventory.noImage }}</span>
            </div>
          </div>
          <div class="buttons">
            <van-button
              class="search-btn"
              size="small"
              type="primary"
              @click="gotoQuotation(item.PId)"
              >{{ $t.goodsInventory.productQuotation }}</van-button
            >

            <van-button
              class="primary-btn"
              size="small"
              type="primary"
              @click="gotoDetail(item.PId)"
              >{{ $t.meta.editButton }}</van-button
            >

            <van-button
              :class="item.ProductState == '1' ? 'default-btn' : 'search-btn'"
              size="small"
              type="primary"
              @click="editProductStateByPId(item)"
            >
              <span v-if="item.ProductState == '1'">{{ $t.meta.disable }}</span>
              <span v-else>{{ $t.meta.enable }}</span></van-button
            >

            <van-button
              class="danger-btn"
              size="small"
              type="primary"
              @click="dialogDeleteShow(item.PId)"
              >{{ $t.meta.delete }}</van-button
            >
          </div>
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="orderBy" direction="horizontal">
          <van-radio :name="0">{{ $t.goodsInventory.orderBy1 }}</van-radio>
          <van-radio :name="1">{{ $t.goodsInventory.orderBy2 }}</van-radio>
          <van-radio :name="2">{{ $t.goodsInventory.orderBy3 }}</van-radio>
        </van-radio-group>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-dialog
      :title="$t.meta.notice"
      width="90%"
      v-model="showDeleteDialog"
      @confirm="deleteProcurementProduct"
      @cancel="showDeleteDialog = false"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        {{ $t.meta.deleteConfirm }}
      </div>
    </van-dialog>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoDetail(null)">{{
        $t.goodsInventory.createProduct
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Popup,
  Picker,
  Radio,
  RadioGroup,
  Image,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Popup)
  .use(Picker)
  .use(Radio)
  .use(RadioGroup)
  .use(Image);

export default {
  name: "goodsInventory",
  data() {
    return {
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.goodsInventory.productName,
          value: 1,
        },
        {
          text: this.$t.goodsInventory.hsCode,
          value: 2,
        },
        {
          text: this.$t.goodsInventory.customerNumber,
          value: 3,
        },
        {
          text: this.$t.goodsInventory.customerName,
          value: 4,
        },
      ],
      showFilter: false,
      productState: null,
      orderBy: 0,
      //删除订单
      showDeleteDialog: false,
      dialogDeleteId: null,
    };
  },
  created() {},
  methods: {
    gotoQuotation(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "goodsInventoryQuotation",
        name: "goodsInventoryQuotation",
        query: [
          {
            name: "PId",
            value: id ? id : null,
          },
        ],
      });
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "goodsInventoryCreate",
        name: "goodsInventoryCreate",
        query: [
          {
            name: "PId",
            value: id ? id : null,
          },
        ],
      });
    },
    editProductStateByPId(item) {
      this.$commonMethod.showLoading();
      var param = {
        PId: item.PId,
        ProductState: Number(item.ProductState == 1) ? -1 : 1,
      };
      this.$api.purchasingManagement
        .editProductStateByPId(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.tableData = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    deleteProcurementProduct() {
      this.$commonMethod.showLoading();
      var param = {
        PId: this.dialogDeleteId,
      };
      this.$api.purchasingManagement
        .deleteProcurementProduct(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.showDeleteDialog = false;
          this.tableData = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogDeleteShow(id) {
      this.dialogDeleteId = id;
      this.showDeleteDialog = true;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.productState) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.productState = null;
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        ProductName: this.searchType == 1 ? this.searchText : "",
        HSCode: this.searchType == 2 ? this.searchText : "",
        CustomerNumber: this.searchType == 3 ? this.searchText : "",
        CustomerName: this.searchType == 4 ? this.searchText : "",
        OrderBy: this.orderBy,
        ProductState: this.productState,
      };
      this.$api.purchasingManagement
        .getProcurementProductListByPage(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.goodsInventory {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .left {
        vertical-align: middle;
        display: inline-block;
        width: 60%;
        margin-bottom: 10px;
        .list-item {
          margin-bottom: 10px;
        }
        .list-item:last-child {
          margin-bottom: 0px;
        }
      }
      .right {
        vertical-align: middle;
        display: inline-block;
        width: 40%;
        .images {
          overflow: hidden;
          vertical-align: middle;
          text-align: center;
          ::v-deep img {
            border-radius: 8px;
          }
        }
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
